module.exports = __webpack_public_path__ + "img/shop_4-1.591febdf.jpg";